import script from "./PartnerAddBulkModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerAddBulkModal.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/pc/account.css?vue&type=style&index=0&id=5be690bb&scoped=true&lang=css&external"
import "./PartnerAddBulkModal.vue?vue&type=style&index=1&id=5be690bb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5be690bb"]])

export default __exports__